// Match PHP 8.3's two-decimal rounding, including its decimal pre-rounding.
// This corrects binary drift at half-paisa boundaries without an amount-based
// epsilon that could move values below the boundary into the next paisa.
const roundMoney = (value) => {
  const number = Number(value) || 0;
  if (number === 0 || !Number.isFinite(number)) return number;
  const magnitude = Math.abs(number);
  const precision = 14 - Math.floor(Math.log10(magnitude));
  let scaled = magnitude * 100;
  if (precision > 2 && precision - 2 < 15) {
    scaled = Math.floor(magnitude * 10 ** precision + 0.5) / 10 ** (precision - 2);
  } else if (scaled >= 1e15) {
    return number;
  }
  return Math.sign(number) * Math.floor(scaled + 0.5) / 100;
};

export const clientInvoiceAmounts = (sourceAmountUsd, exchangeRate, requestedTax, taxRule = {}, currencyCode = "INR") => {
  const source = roundMoney(sourceAmountUsd);
  const gross = roundMoney(source * (Number(exchangeRate) || 0));
  const taxEnabled = Boolean(requestedTax && taxRule.applicable);
  const percentage = taxEnabled ? roundMoney(taxRule.percentage || 0) : 0;
  let amount = percentage > 0 ? roundMoney(gross / (1 + percentage / 100)) : gross;
  let tax = roundMoney(gross - amount);
  let cgst = 0;
  let sgst = 0;
  let igst = 0;

  if (taxEnabled && taxRule.rule === "india_same_state") {
    if (String(currencyCode).trim().toUpperCase() === "INR") {
      cgst = roundMoney(amount * percentage / 200);
      sgst = cgst;
      tax = roundMoney(cgst + sgst);
      amount = roundMoney(gross - tax);
    } else {
      cgst = roundMoney(tax / 2);
      sgst = roundMoney(tax - cgst);
    }
  } else if (taxEnabled && taxRule.rule === "india_interstate") {
    igst = tax;
  }

  return { amount, cgst, sgst, igst, tax, total: gross, percentage };
};
